/** Порог беглого припоминания. Один на оба типа заданий: направление
 *  разницы между типами не измерено (решение (j)). */
export const SPEED_THRESHOLD_MS = 3000;

/** Замер не годится, если ответ по этому факту раскрывали менее чем
 *  столько назад (раздел 6.2). */
export const REVEAL_WINDOW_MS = 12 * 60 * 60 * 1000;

/** Минимальный разброс между первым и последним замером окна скорости
 *  для статуса «Освоен» (решение (l)). */
export const SPREAD_MIN_MS = 12 * 60 * 60 * 1000;

/** После стольких ошибок подряд задание закрывается с подсказкой
 *  (решение (m)). */
export const MAX_CONSECUTIVE_ERRORS = 3;
